<template>
  <div class="footer">
    <div class="footer-container">
      <el-row :gutter="20">
        <!-- 左侧列：联系我们 -->
        <el-col :span="18" :xs="24">
          <div class="footer-block">
            <div class="footer-info">
              <span class="info-item">联系地址：保山市隆阳区青阳路与龙泉路交叉口</span>
              <span class="info-item">联系电话：15334341973</span>
              <span class="info-item">邮箱：contact@company.com</span>
            </div>
          </div>
        </el-col>
        <!-- 右侧列：相关系统 -->
        <el-col :span="6" :xs="24" class="text-right">
          <div class="footer-block">
            <h3 class="footer-title"></h3>
            <div class="footer-links">
<!--              <a href="" class="link-item">管理后台</a>-->
<!--              <span class="link-item" @click="navigateToNewWindow">评委客户端</span>-->
            </div>
          </div>
        </el-col>
      </el-row>


    <div class="footer-bottom">
      <div class="copyright">
        © 2026 公司名称 版权所有 | 滇ICP备2026010382号-1
      </div>
      <div class="legal-links">
        <a href="#">隐私政策</a>
        <a href="#">使用条款</a>
        <a href="#">法律声明</a>
        <a href="http://8.156.95.4/admin/login?redirect=/index" target="_blank" rel="noopener noreferrer">管理后台</a>
      </div>
    </div>
  </div>
  </div>
</template>
<script setup>
// import {useRouter} from "vue-router";

// const router = useRouter();
// const navigateToNewWindow = () => {
//   // window.open(router.resolve({ path: '/score' }).href, '_blank');
//   router.push('/score');
// };

</script>
<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: 'Segoe UI', 'Microsoft YaHei', sans-serif;
}

.footer {
  background-color: #2d323d;
  color: #a9b0c0;
  padding: 15px 0 ;
}

.footer-container {
  max-width: 1200px;
  width: 80%;
  margin: 0 auto;
  padding: 0 10px;
}

.footer-block {
  display: flex;
  flex-direction: column;
  gap: 15px;
}
.footer-title {
  font-size: 16px;
  font-weight: 500;
  margin: 0;
  color: white;
  text-align: left;
}
/* 左侧信息排列 */
.footer-info {
  display: flex;
  gap: 30px; /* 信息之间的间距 */
  flex-wrap: wrap;
}

.info-item {
  white-space: nowrap; /* 防止文字换行 */
}

/* 右侧链接排列 */
.footer-links {
  display: flex;
  justify-content: flex-end; /* 靠右对齐 */
  gap: 40px;
}

.link-item {
  text-decoration: none;
  color: #606266;
  cursor: pointer;
}

.link-item:hover {
  color: #409eff; /*  hover 变蓝 */
}

.footer-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 30px;
  margin-bottom: 20px;
}

.footer-column h3 {
  color: white;
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 10px;
  position: relative;
  padding-bottom: 10px;
}

.footer-column h3::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 30px;
  height: 2px;


}

.footer-column ul {
  list-style: none;
}

.footer-column ul li {
  margin-bottom: 12px;

}

.footer-column ul li a {
  color: #a9b0c0;
  text-decoration: none;
  font-size: 14px;
  transition: color 0.3s;
}

.footer-column ul li a:hover {
  color: #007bff;
}

.contact-info p {
  font-size: 14px;
  line-height: 1.8;
  margin-bottom: 10px;
  display: flex;
  align-items: flex-start;
}

.contact-info i {
  margin-right: 10px;
  color: #007bff;
  font-size: 16px;
  min-width: 20px;
}
.footer-bottom {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 10px;
  border-top: 1px solid rgba(255,255,255,0.05);
  margin-top: 10px;
  font-size: 13px;
}

.copyright {
  color: #7a7d86;
}

.legal-links a {
  color: #7a7d86;
  text-decoration: none;
  margin-left: 15px;
  transition: color 0.3s;
}

.legal-links a:hover {
  color: #007bff;
}

@media (max-width: 992px) {
  .footer-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 576px) {
  .footer-grid {
    grid-template-columns: 1fr;
    gap: 40px;
  }

  .footer-bottom {
    flex-direction: column;
    gap: 15px;
    text-align: center;
  }

  .legal-links {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .legal-links a {
    margin: 0;
  }
}
</style>